import {ManageCvs } from './manage-cvs';
import { ManageCvsProvider } from './manage-cvs.provider';

export const FeatureManageCvs = () => {
   return (
      <ManageCvsProvider>
         <ManageCvs></ManageCvs>
      </ManageCvsProvider>
   );
};
